import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Outlet, useLocation } from 'react-router-dom';
import AdditionalInformation from '@components/Settings/AdditionalInformation/AdditionalInformation';
import MainBackground from '@components/Settings/MainBackground/MainBackground';

import { useAirdropQuery, useExtendedInfoQuery } from '@/api/queries/user';
import AirdropBody from '@/components/Airdrop/AirdropBody/AirdropBody';
import { Wallet } from '@/components/Settings/Wallet/Wallet';
import { Tab } from '@/components/Tabs/Tab';
import { Tabs } from '@/components/Tabs/Tabs';
import { TabsNavigation } from '@/components/Tabs/TabsNavigation';

const Settings: React.FC = () => {
  const location = useLocation();
  const state = location.state as { activeTab: string } | undefined;
  useAirdropQuery();
  useExtendedInfoQuery();

  const tabs = [
    {
      id: '1',
      label: 'Account',
    },
    {
      id: '2',
      label: 'Overview',
    },
  ];

  return (
    <>
      {location.pathname === '/settings' ? (
        <main>
          <Helmet>
            <title>Settings</title>
          </Helmet>
          <MainBackground />
          <Tabs initActiveTab={state?.activeTab || '1'}>
            <div className="px-2 mb-4 relative flex gap-2">
              <TabsNavigation list={tabs} indexWithIndicator={undefined} />
            </div>
            <Tab className="w-full" tabId="1">
              <div
                className="tabs tabs--sticky"
                style={{ padding: '0 0.5rem' }}
              >
                <Wallet />
                <AdditionalInformation />
              </div>
            </Tab>
            <Tab className="w-full" tabId="2">
              <AirdropBody />
            </Tab>
          </Tabs>
          <div className="w-full text-center text-xs opacity-50 py-4">
            v{__APP_VERSION__}
          </div>
        </main>
      ) : (
        <Outlet />
      )}
    </>
  );
};

export default Settings;
